var ruler = {
  /**
   * 初始化刻度尺插件
   * @el 容器 String
   * @height 刻度尺高度 Number
   * @maxScale 最大刻度 Number
   * @startValue 开始的值 Number
   * @region 区间 Array
   * @background 刻度尺背景颜色 String
   * @color 刻度线和字体的颜色 String
   * @markColor  中心刻度标记颜色 String
   * @isConstant 是否不断地获取值 Boolean
   * @success(res) 滑动结束后的回调 Function
   * */
  initPlugin: function (params) {
    var initParams = {
      el: params.el,
      uom: params.uom || "in",
      height: params.height || 95,
      maxScale: params.maxScale || 200,
      startValue: params.startValue || 0,
      region: params.region || false,
      background: params.background || false,
      color: params.color || false,
      markColor: params.markColor || "#DDC9B3",
      isConstant: params.isConstant || false,
    };

    if (!initParams.el) {
      console.warn("没有容器元素的参数");
      return false;
    }

    var rulerWrap = document.getElementById(initParams.el); //获取容器
    rulerWrap.style.height =
      initParams.height < 50 ? 50 + "px" : initParams.height + "px";

    //最大刻度的小值是50
    initParams.maxScale = initParams.maxScale < 50 ? 50 : initParams.maxScale;

    if (initParams.startValue > initParams.maxScale) {
      initParams.startValue = initParams.maxScale;
    }

    var minSildeNum = 0; //最小滑动的值
    var maxSildeNum = initParams.maxScale; //最大滑动的值

    if (initParams.region) {
      minSildeNum = Math.floor(initParams.region[0]);
      maxSildeNum = Math.floor(initParams.region[1]);
    }

    var count = initParams.startValue; //初始值

    var winWidth = rulerWrap.offsetWidth; //容器宽度
    var division = winWidth / 14; //每个刻度的距离 分割线
    //刻度值数组
    var scaleValueList = [];

    switch (initParams.uom) {
      case "in":
        for (var i = 0; i <= initParams.maxScale; i++) {
          var inch =
            i / 10 > 1 ? Math.floor(i / 10) + "'" + (i % 10) + '"' : i + '"';
          scaleValueList.push(inch);
        }
        break;
      default:
        for (var i = 0; i <= initParams.maxScale; i += 3) {
          scaleValueList.push(i);
        }
    }

    var canvas = rulerWrap.getElementsByTagName("canvas")[0]; //获取容器下的canvas标签
    // 有则先移除再创建
    if (canvas) {
      rulerWrap.removeChild(canvas);
    }
    canvas = document.createElement("canvas"); //创建canvas标签
    canvas.width = winWidth;
    canvas.height = initParams.height;
    var bottomLineY = initParams.height - 8;
    rulerWrap.appendChild(canvas);
    var cxt = canvas.getContext("2d");

    //画刻度尺
    function drawRuler(count) {
      if (window.devicePixelRatio) {
        canvas.width = window.devicePixelRatio * winWidth;
        canvas.height = window.devicePixelRatio * initParams.height;
        cxt.scale(window.devicePixelRatio, window.devicePixelRatio);
      }

      if (window.devicePixelRatio) {
        canvas.style.transform = "scale(" + 1 / window.devicePixelRatio + ")";
        canvas.style.transformOrigin = "left top";
      }

      count = count - 7;

      //清空画布
      cxt.clearRect(0, 0, winWidth, initParams.height);

      //刻度尺背景
      if (initParams.background) {
        cxt.fillStyle = initParams.background;
        cxt.fillRect(0, 0, canvas.width, initParams.height);
      }

      // 画底部的双箭头线条
      drawArrow(
        cxt,
        winWidth / 2 - division * 6.99,
        bottomLineY,
        winWidth / 2 + division * 6.99,
        bottomLineY
      );

      //画刻度线
      for (var i = 0; i < initParams.maxScale; i++) {
        cxt.beginPath();
        cxt.save();
        cxt.strokeStyle = initParams.color ? initParams.color : "#000";
        cxt.lineWidth = 1;
        cxt.lineCap = "round";
        cxt.moveTo(division * i - count * division, bottomLineY);

        if (i % 3 !== 0 && i != 0 && i != count) {
          cxt.lineTo(
            division * i - count * division,
            Math.floor(bottomLineY * 0.9)
          );
        }

        if (i % 3 === 0) {
          cxt.strokeStyle = initParams.color ? initParams.color : "#000";
          cxt.lineTo(
            division * i - count * division,
            Math.floor(bottomLineY * 0.8)
          );
        }
        /* if (i % 10 === 0) {
          cxt.strokeStyle = initParams.color ? initParams.color : "#666";
          cxt.lineTo(
            division * i - count * division,
            Math.floor(bottomLineX * 0.6)
          );
        } */

        cxt.stroke();
        cxt.restore();
        cxt.closePath();
      }

      //添加数字
      cxt.beginPath();
      cxt.font = "15px Arial";
      cxt.fillStyle = initParams.color ? initParams.color : "#333";
      cxt.textAlign = "center";
      cxt.textBaseline = "middle";
      scaleValueList.forEach(function (num, i) {
        if ("in" == initParams.uom && i >= 3 && i % 3 == 0) {
          cxt.fillText(
            num.toString(),
            division * i - count * division,
            Math.floor(bottomLineY * 0.3)
          );
        } else if ("in" != initParams.uom) {
          cxt.fillText(
            num.toString(),
            division * i * 3 - count * division,
            Math.floor(bottomLineY * 0.3)
          );
        }
      });
      cxt.closePath();

      //中心刻度线
      cxt.beginPath();
      cxt.save();
      cxt.strokeStyle = initParams.markColor;
      cxt.lineWidth = 3;
      cxt.lineCap = "round";
      cxt.moveTo(winWidth / 2, bottomLineY);
      cxt.lineTo(winWidth / 2, Math.floor(bottomLineY * 0.6));
      cxt.stroke();
      cxt.restore();
      cxt.closePath();
    }

    drawRuler(count);

    function drawArrow(
      ctx,
      fromX,
      fromY,
      toX,
      toY,
      theta,
      headlen,
      width,
      color
    ) {
      theta = typeof theta != "undefined" ? theta : 40;
      headlen = typeof headlen != "undefined" ? headlen : 5;
      width = typeof width != "undefined" ? width : 1;
      color = typeof color != "color" ? color : "#000";

      var angle = (Math.atan2(fromY - toY, fromX - toX) * 180) / Math.PI,
        angle1 = ((angle + theta) * Math.PI) / 180,
        angle2 = ((angle - theta) * Math.PI) / 180,
        topX = headlen * Math.cos(angle1),
        topY = headlen * Math.sin(angle1),
        botX = headlen * Math.cos(angle2),
        botY = headlen * Math.sin(angle2);

      ctx.save();
      ctx.beginPath();
      ctx.shadowColor = "black";
      ctx.shadowBlur = 15;
      ctx.shadowOffsetX = 0;
      ctx.shadowOffsetY = 8;
      var arrowX = fromX - topX,
        arrowY = fromY - topY;
      ctx.moveTo(arrowX, arrowY);
      ctx.lineTo(fromX, fromY);
      arrowX = fromX - botX;
      arrowY = fromY - botY;
      ctx.lineTo(arrowX, arrowY);
      ctx.moveTo(fromX, fromY);
      ctx.lineTo(toX, toY);

      //Reverse length on the other side
      arrowX = toX + topX;
      arrowY = toY + topY;
      ctx.moveTo(arrowX, arrowY);
      ctx.lineTo(toX, toY);
      arrowX = toX + botX;
      arrowY = toY + botY;
      ctx.lineTo(arrowX, arrowY);
      ctx.strokeStyle = color;
      ctx.lineWidth = width;
      ctx.stroke();
      ctx.restore();
    }

    var floatSeizeSeatDiv = rulerWrap.parentElement.querySelector(
      ".float-seize-seat-div"
    );
    var floatDiv;
    if (!floatSeizeSeatDiv) {
      floatSeizeSeatDiv = document.createElement("div");
      floatSeizeSeatDiv.classList.add("float-seize-seat-div");
      floatDiv = document.createElement("div");
      floatDiv.classList.add("rule-float-div");
      floatSeizeSeatDiv.appendChild(floatDiv);
      rulerWrap.parentElement.append(floatSeizeSeatDiv);
    }

    floatDiv = floatSeizeSeatDiv.firstChild;
    var firstSpan = floatDiv.querySelector(".first");
    if (!firstSpan) {
      firstSpan = document.createElement("span");
      firstSpan.classList.add("first");
    }

    var secondSpan = floatDiv.querySelector(".second");
    if (!secondSpan) {
      secondSpan = document.createElement("span");
      secondSpan.classList.add("second");
    }

    var removeThirdAndFour = false;
    var thirdSpan = floatDiv.querySelector(".third");
    if (!thirdSpan) {
      thirdSpan = document.createElement("span");
      thirdSpan.classList.add("third");
    } else {
      removeThirdAndFour = true;
    }

    var fourthSpan = floatDiv.querySelector(".fourth");
    if (!fourthSpan) {
      fourthSpan = document.createElement("span");
      fourthSpan.classList.add("fourth");
    } else {
      removeThirdAndFour = true;
    }
    if (initParams.uom == "in") {
      if (initParams.startValue / 10 > 1) {
        firstSpan.textContent = Math.floor(initParams.startValue / 10);
        secondSpan.textContent = " ft ";
        thirdSpan.textContent = initParams.startValue % 10;
        fourthSpan.textContent = " in";
        floatDiv.appendChild(firstSpan);
        floatDiv.appendChild(secondSpan);
        floatDiv.appendChild(thirdSpan);
        floatDiv.appendChild(fourthSpan);
      } else {
        firstSpan.textContent = initParams.startValue + " ";
        secondSpan.textContent = initParams.uom;
        if (removeThirdAndFour) {
          floatDiv.removeChild(thirdSpan);
          floatDiv.removeChild(fourthSpan);
        }
        floatDiv.appendChild(firstSpan);
        floatDiv.appendChild(secondSpan);
      }
    } else {
      firstSpan.textContent = initParams.startValue + " ";
      secondSpan.textContent = initParams.uom;
      if (removeThirdAndFour) {
        floatDiv.removeChild(thirdSpan);
        floatDiv.removeChild(fourthSpan);
      }
      floatDiv.appendChild(firstSpan);
      floatDiv.appendChild(secondSpan);
    }
    params.success && params.success(count);

    //滑动相关
    var initX = 0, //初始x 距离
      endX = 0, //结束x 距离
      distanceX = 0, //移动距离
      _distanceX = 0, // 判断用的移动距离
      lastX = count; //上次移动距离

    if (!canvas) return false;

    //手指按下
    canvas.addEventListener(
      "touchstart",
      function (e) {
        e.preventDefault();
        initX = e.targetTouches[0].pageX;
      },
      true
    );

    //手指滑动
    canvas.addEventListener(
      "touchmove",
      function (e) {
        e.preventDefault();
        endX = e.targetTouches[0].pageX;
        moveEvent();
      },
      true
    );

    //手指抬起
    canvas.addEventListener(
      "touchend",
      function (e) {
        e.preventDefault();
        lastX = count;
        overEvent();
      },
      true
    );

    var isMouseDown = false; //鼠标是否按下

    //鼠标按下
    canvas.addEventListener(
      "mousedown",
      function (e) {
        e.preventDefault();
        isMouseDown = true;
        initX = e.layerX;
      },
      true
    );

    //鼠标移动
    canvas.addEventListener(
      "mousemove",
      function (e) {
        e.preventDefault();
        if (!isMouseDown) {
          return false;
        }
        endX = e.layerX;
        moveEvent();
      },
      true
    );

    //鼠标抬起&离开
    canvas.addEventListener(
      "mouseup",
      function (e) {
        e.preventDefault();
        lastX = count;
        isMouseDown = false;
        overEvent();
      },
      true
    );

    canvas.addEventListener(
      "mouseleave",
      function (e) {
        e.preventDefault();
        if (isMouseDown) {
          lastX = count;
          isMouseDown = false;
          overEvent();
        }
      },
      true
    );

    //手指&鼠标移动事件
    function moveEvent() {
      // 计算移动距离
      distanceX = Math.floor((initX - endX) / (winWidth / 14));
      if (distanceX === _distanceX) {
        return false;
      }
      _distanceX = distanceX;
      count = lastX + distanceX;

      // 当移动到终点或起点时，让移动总距离归为最大或零，避免选择到超过最大值或小于0的值
      if (count >= initParams.maxScale || count <= 0) {
        count = count >= initParams.maxScale ? initParams.maxScale : 0;
      }
      drawRuler(count);

      console.log("移动时：endX = " + endX + " ,initX =" + initX + " , lastX");
      if (initParams.isConstant) {
        params.success && params.success(count);
      }
    }

    //手指&鼠标结束事件
    function overEvent() {
      if (count > maxSildeNum) {
        lastX = count = count > maxSildeNum ? maxSildeNum : count;
      } else if (count < minSildeNum) {
        lastX = count = count < minSildeNum ? minSildeNum : count;
      } else {
      }
      drawRuler(count);

      //返回最后的值
      params.success && params.success(count);
    }
  },
};

var ajax = {
  get: function (url, fn) {
    // XMLHttpRequest对象用于在后台与服务器交换数据
    var xhr = new XMLHttpRequest();
    xhr.open("GET", url, true);
    xhr.onreadystatechange = function () {
      // readyState == 4说明请求已完成
      if ((xhr.readyState == 4 && xhr.status == 200) || xhr.status == 304) {
        // 从服务器获得数据
        fn.call(this, xhr.responseText);
      }
    };
    xhr.send();
  },
  // datat应为json字符串格式，在jq里如果data为对象会自动将对象转成这种字符串格式
  post: function (url, data, fn, fe) {
    console.log("post data: ", data);
    var xhr = new XMLHttpRequest();
    xhr.timeout = 3000;
    xhr.open("POST", url, true);
    // 添加http头，发送信息至服务器时内容编码类型
    xhr.setRequestHeader("Content-Type", "application/json; charset=utf-8");
    xhr.onload = function () {
      var text = xhr.responseText;
      if (text.includes('"')) {
        text = text.replaceAll('"', "");
      }
      if (xhr.readyState == 4 && (xhr.status == 200 || xhr.status == 304)) {
        fn.call(this, text);
      } else if (xhr.status == 204) {
        fn.call(this, text);
      } else {
        fe.call(this, "status error: " + text);
      }
    };

    xhr.onerror = function (error) {
      fe.call(this, "server error: " + error);
    };
    xhr.ontimeout = function (error) {
      fe.call(this, "timeout: " + error);
    };
    data = JSON.stringify(data);
    xhr.send(data);
  },
};
